import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=1aabb1d4&scoped=true&"
import script from "./Inventories.vue?vue&type=script&lang=js&"
export * from "./Inventories.vue?vue&type=script&lang=js&"
import style0 from "./Inventories.vue?vue&type=style&index=0&id=1aabb1d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabb1d4",
  null
  
)

export default component.exports